import React from 'react'
import DailerPopup from './components/DailerPopup'
import reducer from './store'
import { injectReducer } from 'store'

injectReducer('dailerApp', reducer)

export default function DailerIndex() {
  return (
    <div><DailerPopup /></div>
  )
}
